import { CapManageControllerContext } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/CapManageEntityFlow.tsx';
import { useContext, useMemo } from 'react';
import { DIRECTORY_BREADCRUMBS } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/shared/directoryBreadcrumbs.tsx';
import { PEOPLE_ROUTES } from '@dealstack/frontend/app/pages/Routing/routes.ts';
import { useBreadcrumbs } from '@dealstack/frontend/shared/components/Breadcrumbs/useBreadcrumbs.tsx';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { CreatePersonTabs } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/CapManageSidebar/CreatePersonTabs/CreatePersonTabs.tsx';

export const InitialPage = () => {
	const tCapManage = useTranslationCapManage();
	const { dealId } = useContext(CapManageControllerContext);
	const {
		createEntityMode,
		setCreateEntityMode,
		refetchPersonsAndTags,
		setSelectedEntityId,
		setNewEntityComputedName,
	} = useContext(CapManageControllerContext);

	const breadcrumbs = useMemo(
		() =>
			DIRECTORY_BREADCRUMBS[PEOPLE_ROUTES.INITIAL]({
				tCapManage,
				dealId,
			}),
		[tCapManage, dealId]
	);

	useBreadcrumbs(breadcrumbs);

	const onCreateEntitySuccess = async (createdEntityId: string, withClose?: boolean) => {
		await refetchPersonsAndTags();

		if (createdEntityId && withClose) {
			setSelectedEntityId(createdEntityId, PEOPLE_ROUTES.PERSON_DETAILS);
			setCreateEntityMode(null);
		}
	};

	return createEntityMode ? (
		<CreatePersonTabs
			dealId={dealId}
			onCreateSuccess={onCreateEntitySuccess}
			onCancel={() => setCreateEntityMode(null)}
			setCreateEntityMode={setCreateEntityMode}
			setComputedName={setNewEntityComputedName}
		/>
	) : null;
};
